<template>
  <div class="aiToolPage">
    <div class="accessFormContainer" v-if="showAccess">
      <div class="accessForm">
        <div class="accessFormTitle">AI工具授权</div>
        <Form :label-width="60" :model="accessForm" :rules="accessFormValidate" ref="accessForm">
          <FormItem label="AK" prop="appKey">
            <Input placeholder="请输入标签" type="text" v-model.trim="accessForm.appKey"></Input>
          </FormItem>
          <FormItem label="SK" prop="appSecret">
            <Input placeholder="请输入值" type="text" v-model.trim="accessForm.appSecret"></Input>
          </FormItem>
        </Form>
        <Button @click="saveAccessForm" style="width: 100%;margin: 10px 0;" type="primary">授权</Button>
      </div>
    </div>
    <template v-else>
      <Spin fix v-if="loading">
        <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
        <div>{{tips}}</div>
      </Spin>
      <aiChartH5 :chartId="chartId" :configId="configId" :prompt="currentPrompt" v-if="!loading" />
    </template>
  </div>
</template>
<script>
export default {
  name: 'aiTool',
  data () {
    return {
      isChart: true,
      chartId: '',
      configId: '',
      currentPrompt: {},
      appKey: '',
      appSecret: '',
      toolCode: '',
      loading: true,
      tips: '',
      showAccess: false,
      accessFormValidate: {
        appKey: [{ required: true, message: '请填写AK', trigger: "blur" }],
        appSecret: [{ required: true, message: '请填写SK', trigger: "blur" }],
      },
      accessForm: {
        appKey: '',
        appSecret: '',
      },
    }
  },
  methods: {
    getAIToolPrompt: function () {
      let that = this
      this.tips = 'AI工具加载中'
      this.loading = true
      let params = new this.$URLSearchParams()
      params.append("toolCode", this.toolCode)
      this.$axiosH5.post(that.$apis.aiToolSupport.getAIToolPrompt, params).then(res => {
        if (res.success) {
          let data = res.result || {}
          this.currentPrompt = data.prompt || {}
          this.accessForm.appKey = data.AK
          this.accessForm.appSecret = data.SK
          this.configId = this.currentPrompt.modelConfigId
          if (this.chartId == undefined || this.chartId.trim() == '') {
            this.chartId = this.accessForm.appKey + '_' + this.toolCode + '_' + this.$moment().format('YYYY-MM-DD')
          }
          setTimeout(() => {
            that.loading = false
          }, 1000)
        } else {
          that.tips = res.message
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('err', err)
        that.tips = '获取AI工具失败！'
        that.$Message.error("获取AI工具失败！")
      })
    },
    getToken: function () {
      let that = this
      let params = new this.$URLSearchParams()
      params.append("appKey", this.accessForm.appKey)
      params.append("appSecret", this.accessForm.appSecret)
      this.$axiosH5.post(that.$apis.aiToolSupport.getToken, params).then(res => {
        if (res.success) {
          this.showAccess = false
          localStorage.setItem("h5Token", res.result)
          this.getAIToolPrompt()
        } else {
          that.tips = res.message
          that.$Message.error({
            content: res.message,
            duration: 3
          })
        }
      }).catch(function (err) {
        that.$Message.error({
          content: "授权失败！",
          duration: 3
        })
      })
    },
    saveAccessForm: function () {
      let that = this
      this.$refs.accessForm.validate(valid => {
        if (valid) {
          this.getToken()
        } else {
          return false
        }
      })
    },
    cancelAccess: function () {
      this.showAccess = false
    }
  },
  beforeMount () {
    let params = this.$route.query || {}
    this.accessForm.appKey = params.appKey
    this.accessForm.appSecret = params.appSecret
    this.toolCode = params.toolCode || 'lawyerAI'
    this.chartId = params.chartId
    let h5Token = localStorage.getItem('h5Token')
    console.log('h5Token', h5Token)
    if (params.appKey == undefined || params.appKey.trim() == '' || params.appSecret == undefined || params.appSecret.trim() == '') {
      if (h5Token) {
        this.showAccess = false
        this.getAIToolPrompt()
      } else {
        this.showAccess = true
      }
    } else {
      this.getToken()
    }
  }
}
</script>
<style lang="less" scoped>
.aiToolPage {
  width: 100%;
  height: 100%;
  min-width: 220px;
  overflow: hidden;

  .accessFormContainer {
    width: 100%;
    height: 100%;
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;

    .accessForm {
      padding: 1rem;
      margin: 1rem;
      background: #fff;
      border-radius: 10px;
      width: 100%;
      min-width: 320px;
      box-shadow: 4px 3px 5px 2px #eee;
      max-width: 500px;

      .accessFormTitle {
        font-weight: 500;
        margin-bottom: 1rem;
        font-size: 1.2rem;
      }
    }
  }
}
</style>